import { ERCButton } from "components/button";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { apiRequest } from "services";
import Loader from "components/Loader";

const ERCForm = ({
  btnText,
  btnClass,
  className,
  children,
  url,
  method,
  extraFields = {},
  successMessage,
  validationSchema,
  noToken,
  inputsContainer,
  onSuccess = () => null,
  onSubmit = () => null,
  onError = () => null,
  modifyPayload = () => null,
}) => {
  const [loading, setLoading] = useState(false);
  const callApi = async (payload) => {
    let params = {};
    if (method === "get" && payload) params = { ...payload };
    setLoading(true);
    try {
      console.log("payload", payload);
      const roles = payload.userType;
      console.log(roles, "roles");
      window.sessionStorage.setItem("#roles", JSON.stringify(roles));
      let final_payload = modifyPayload(payload) || payload;
      const res = await apiRequest({
        method,
        url,
        payload: final_payload,
        params,
        noToken,
      });
      console.log(res, "userResponse");
      window.sessionStorage.setItem(
        "#userId",
        JSON.stringify(res?.data?.details?.id)
      );
      if (res?.data.status === "success") {
        console.log("successsssssssssssssssssss")
        toast.success(res?.data.message);
      } else {
        toast.success(res?.data?.message || "Successful");
      }
      onSuccess(res, payload);
    } catch (error) {
      onError(error);
      console.log(error);
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false); // Ensure loading is always set to false after API call
    }
  };
  const submit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    let formValues = {};
    for (let [key, value] of formData.entries()) {
      formValues[key] = value;
    }
    formValues = { ...formValues, ...extraFields };
    onSubmit(formValues);
    // console.log(formValues)
    if (validationSchema) {
      try {
        await validationSchema.validate(formValues, { abortEarly: false });
        callApi(formValues);
      } catch (error) {
        const errs = error.errors;
        errs.forEach((err) => {
          toast.error(err);
        });
      }
    } else {
      callApi(formValues);
    }
  };

  return (
    <form onSubmit={submit} className={className}>
      <div className={`${inputsContainer}`}>{children}</div>
      {btnText && (
        <ERCButton
          className={`${btnClass} p-3`}
          type="submit"
          loading={loading}
          disabled={loading} // Add disabled state when loading
        >
           {loading ? (<Loader color={"#00296B"} />) : btnText}
        </ERCButton>
      )}
    </form>
  );  
};

export { ERCForm };